module.exports = __webpack_public_path__ + "public/Icons/10Managedeliverytype.svg?988fa4a0";